import { DepartmentActionTypes } from "./department-types";

const INITIAL_STATE = {
  allDepartments: null,
  searchDepartmentsQuery: {
    pageSize: 10,
    pageNumber: 1,
    sortDesc: false,
    sortBy: "Name",
    filters: [],
  },
  isFetchingDepartments: false,
  isFetchingAllDepartments: false,
  departments: [],
  departmentsOnPage: null,
  numDepartments: 0,
  selectedDepartments: [],
};

const departmentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DepartmentActionTypes.FETCH_DEPARTMENTS_START:
      return {
        ...state,
        isFetchingDepartments: true,
      };

    case DepartmentActionTypes.SET_ALL_DEPARTMENTS:
      return {
        ...state,
        isFetchingAllDepartments: false,
        departments: action.payload,
      };

    case DepartmentActionTypes.FETCH_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        isFetchingDepartments: false,
        departments: action.payload[0],
        numDepartments: action.payload[1],
      };

    case DepartmentActionTypes.FETCH_DEPARTMENTS_FAILURE:
      return {
        ...state,
        isFetchingDepartments: false,
        errorMessage: action.payload,
      };
    case DepartmentActionTypes.SET_DEPARTMENTS_ON_PAGE: //setting the roles that are displayed on the page
      return {
        ...state,
        departmentsOnPage: action.payload,
      };

    case DepartmentActionTypes.SET_SEARCH_DEPARTMENTS_QUERY:
      return {
        ...state,
        searchDepartmentsQuery: action.payload,
      };
    case DepartmentActionTypes.ADD_SELECTED_DEPARTMENT:
      return {
        ...state,
        selectedDepartments: [...state.selectedDepartments, action.payload],
      };
    case DepartmentActionTypes.DELETE_SELECTED_DEPARTMENT:
      return {
        ...state,
        selectedDepartments: [
          ...state.selectedDepartments.slice(
            0,
            state.selectedDepartments.indexOf(action.payload)
          ),
          ...state.selectedDepartments.slice(
            state.selectedDepartments.indexOf(action.payload) + 1
          ),
        ],
      };
    case DepartmentActionTypes.SET_SELECTED_DEPARTMENT:
      return {
        ...state,
        selectedDepartments: action.payload,
      };

    default:
      return state;
  }
};

export default departmentReducer;
